<script lang="ts">
  import {
    nextCutoffDayAndTime,
    orderIsBelowDollarMinimum,
  } from "@retailer/services/cart_order_service";
  import { CartOrderAlertEntity, CartOrderEntity } from "@shared/services/event_tracking/entities";
  import { trackMrcEvents } from "@shared/services/event_tracking/events";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import type { CartOrderType } from "@shared/types/Cart";

  export let highlightErrors: boolean;
  export let order: CartOrderType;

  const { cutoffTime, cutoffDay } = nextCutoffDayAndTime(order);

  $: isBelowOrderMinimum = orderIsBelowDollarMinimum(order);
  $: needsToReachOrderMinimum =
    isBelowOrderMinimum && order.distributor.reasons?.needs_to_reach_order_minimum;
</script>

{#if !order.distributor.reasons?.has_reached_daily_order_minimum && isBelowOrderMinimum}
  <div
    class:fizz-alert-info={!needsToReachOrderMinimum}
    class:fizz-alert-error={needsToReachOrderMinimum && highlightErrors}
    class:fizz-alert-warning={needsToReachOrderMinimum && !highlightErrors}
    class="fizz-stack-12 fizz-alert--small"
    data-testid="order-alert-{order.distributor.id}"
    use:trackMrcEvents={[
      [
        new CartOrderEntity({ distributorId: order.distributor.id, orderId: order.id }),
        new CartOrderAlertEntity({ alert_type: "below_order_minimum" }),
      ],
    ]}
  >
    <p class="fizz-text-small">
      <span class="fizz-text-strong">
        Order below
        <FormatMoney input={order.distributor.minimum_dollars_per_order} formatType="3" />:
      </span>
      {#if needsToReachOrderMinimum}
        This order cannot be sent without meeting the distributor's order minimum. You're
        <FormatMoney input={order.distributor.minimum_dollars_per_order - order.total} />
        away.
      {:else}
        You're <FormatMoney input={order.distributor.minimum_dollars_per_order - order.total} />
        away from meeting the dollar minimum.
      {/if}
    </p>
  </div>
{:else if order.distributor.reasons?.has_reached_daily_order_minimum}
  <div
    class="fizz-alert-success fizz-stack-12 fizz-alert--small"
    data-testid="order-alert-{order.distributor.id}"
    use:trackMrcEvents={[
      [
        new CartOrderEntity({ distributorId: order.distributor.id, orderId: order.id }),
        new CartOrderAlertEntity({ alert_type: "order_minimum_add_on" }),
      ],
    ]}
  >
    <p class="fizz-text-small">
      <span class="fizz-text-strong">Order minimum met:</span>
      You already met the <FormatMoney
        input={order.distributor.minimum_dollars_per_order}
        formatType="3"
      /> minimum for this order window.
      {#if cutoffDay && cutoffTime}
        You can submit additional orders below the minimum before {cutoffDay} at {cutoffTime}.
      {/if}
    </p>
  </div>
{/if}
